
export const VIEWER_OPEN = "VIEWER_OPEN"

export const VIEWER_CLOSE = "VIEWER_CLOSE"